import React, { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import { labTools, text } from "./constants";

export const Home = () => {
    return (
        <div className={classes.container}>
            <h1>{text.pageTitle}</h1>
            <div className={classes.toolsContainer}>
                {labTools.map(tool => 
                    <a key={tool.name} href={tool.url}>
                        <button className={classes.tool}>
                            <p>{tool.name}</p>
                        </button>
                    </a>
                )}
            </div>
        </div>
    );
}
